import { DeviceFeatures, ModelFeaturesMap, SupportDeviceModel } from "@core/types";

export const MODEL_FEATURES_MAP: ModelFeaturesMap = {
    /* Lagacy Model */
    [SupportDeviceModel._6200]: [
        DeviceFeatures.ROUTER_MODEL_6200_WZL,
        DeviceFeatures.CONFIG_LAGACY_PLATFORM,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING
    ],
    [SupportDeviceModel._6800]: [
        DeviceFeatures.ROUTER_MODEL_6800_RUL,
        DeviceFeatures.CONFIG_LAGACY_PLATFORM,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1
    ],
    [SupportDeviceModel._8920]: [
        DeviceFeatures.ROUTER_MODEL_8920,
        DeviceFeatures.CONFIG_LAGACY_8920_PLATFORM,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1
    ],
    [SupportDeviceModel.M_100]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING
    ],
    [SupportDeviceModel.M_120_N]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER,
        DeviceFeatures.CONFIG_FUNCTION_RGOOSE,
        DeviceFeatures.FUNCTION_SERIAL_PORT_1
    ],
    [SupportDeviceModel.M_120_N_5GR]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_WIRELESS_CLIENT,
        DeviceFeatures.CONFIG_FUNCTION_MULTIPL_BAND_SELECT,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.CONFIG_FUNCTION_VPN_EOIP,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER,
        DeviceFeatures.CONFIG_FUNCTION_RGOOSE,
        DeviceFeatures.FUNCTION_SERIAL_PORT_1,

        DeviceFeatures.CONFIG_FUNCTION_DUAL_SIM
    ],
    [SupportDeviceModel.M_120_N_CM1]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.FUNCTION_WIRELESS_CLIENT,
        DeviceFeatures.CONFIG_FUNCTION_MULTIPL_BAND_SELECT,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.CONFIG_FUNCTION_VPN_EOIP,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER,
        DeviceFeatures.CONFIG_FUNCTION_RGOOSE,
        DeviceFeatures.FUNCTION_SERIAL_PORT_1,
        DeviceFeatures.CONFIG_FUNCTION_NB_IOT,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_SIM,
    ],
    [SupportDeviceModel.M_150]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    [SupportDeviceModel.M_300]: [
        DeviceFeatures.PLATFORM_OPENWRT,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP
    ],
    [SupportDeviceModel.M_300AX]: [
        DeviceFeatures.PLATFORM_OPENWRT,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP
    ],
    [SupportDeviceModel.M_500]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    [SupportDeviceModel.M_600]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.CONFIG_FUNCTION_GPS_RMC_ONLY,
        DeviceFeatures.CONFIG_FUNCTION_GPS_TRACKING,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_WIRELESS_CLIENT,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_SIM,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT
    ],
    [SupportDeviceModel.M_700]: [
        DeviceFeatures.PLATFORM_OPENWRT,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP
    ],

    /////////////////// Overlap Model Here
    [SupportDeviceModel.MX_200]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING
    ],
    [SupportDeviceModel.MX_200E]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING
    ],
    [SupportDeviceModel.MX_200A]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING
    ],
    [SupportDeviceModel.MX_200AE]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING
    ],
    /////////////////// Overlap Model End
    [SupportDeviceModel.MX_210_NP]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_WIRELESS_CLIENT,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN2,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    [SupportDeviceModel.EG_210_N]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN2,
        DeviceFeatures.FUNCTION_FTP
    ],
    /////////////////// Overlap Model Start
    [SupportDeviceModel.MX_220]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BRIDGE_MODE,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_MULTIPL_BAND_SELECT,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_SIM,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.CONFIG_FUNCTION_GPS_RMC_ONLY,
        DeviceFeatures.CONFIG_FUNCTION_GPS_TRACKING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT
    ],
    [SupportDeviceModel.MX_220_UT]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BRIDGE_MODE,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.FUNCTION_3G,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_MULTIPL_BAND_SELECT,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_SIM,
        DeviceFeatures.CONFIG_FUNCTION_E_SIM,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.CONFIG_FUNCTION_GPS_RMC_ONLY,
        DeviceFeatures.CONFIG_FUNCTION_GPS_TRACKING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT,
        DeviceFeatures.CONFIG_FUNCTION_RGOOSE,
        DeviceFeatures.FUNCTION_SERIAL_PORT_1,
        DeviceFeatures.FUNCTION_SERIAL_PORT_2
    ],
    [SupportDeviceModel.MX_220_UT_5G]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BRIDGE_MODE,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_MULTIPL_BAND_SELECT,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_SIM,
        DeviceFeatures.CONFIG_FUNCTION_E_SIM,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.CDM_SCE_MX_220_UT_5G,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.CONFIG_FUNCTION_GPS_RMC_ONLY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT,
        DeviceFeatures.CONFIG_FUNCTION_RGOOSE,
        DeviceFeatures.FUNCTION_SERIAL_PORT_1,
        DeviceFeatures.FUNCTION_SERIAL_PORT_2
    ],
    [SupportDeviceModel.MX_220_UT__5G]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BRIDGE_MODE,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_MULTIPL_BAND_SELECT,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_SIM,
        DeviceFeatures.CONFIG_FUNCTION_E_SIM,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.CDM_SCE_MX_220_UT_5G,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.CONFIG_FUNCTION_GPS_RMC_ONLY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT,
        DeviceFeatures.CONFIG_FUNCTION_RGOOSE,
        DeviceFeatures.FUNCTION_SERIAL_PORT_1,
        DeviceFeatures.FUNCTION_SERIAL_PORT_2
    ],
    [SupportDeviceModel.MX_220F]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_SFP,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BRIDGE_MODE,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_MULTIPL_BAND_SELECT,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_SIM,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.CONFIG_FUNCTION_GPS_RMC_ONLY,
        DeviceFeatures.CONFIG_FUNCTION_GPS_TRACKING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT,
        DeviceFeatures.CONFIG_FUNCTION_RGOOSE,
        DeviceFeatures.FUNCTION_SERIAL_PORT_1,
        DeviceFeatures.FUNCTION_SERIAL_PORT_2
    ],
    [SupportDeviceModel.MX_220_5G]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_SFP,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BRIDGE_MODE,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_MULTIPL_BAND_SELECT,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_SIM,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.CONFIG_FUNCTION_GPS_RMC_ONLY,
        DeviceFeatures.CONFIG_FUNCTION_GPS_TRACKING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT,
        DeviceFeatures.CONFIG_FUNCTION_RGOOSE,
        DeviceFeatures.FUNCTION_SERIAL_PORT_1,
        DeviceFeatures.FUNCTION_SERIAL_PORT_2
    ],
    [SupportDeviceModel.MX_220E_5G]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.CONFIG_FUNCTION_GPS_RMC_ONLY,
        DeviceFeatures.CONFIG_FUNCTION_GPS_TRACKING,
        DeviceFeatures.FUNCTION_5G_NR, // new modified
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING
    ],
    /////////////////// Overlap Model End
    [SupportDeviceModel.MX_221_P]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN2,
        DeviceFeatures.CONFIG_FUNCTION_TRIPLE_SIM,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING
    ],
    [SupportDeviceModel.MX_230]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    [SupportDeviceModel.MX_240]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_5G_NR, // new modified
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING
    ],
    [SupportDeviceModel.MX_241_NP]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_WIRELESS_CLIENT,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN2,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    [SupportDeviceModel.MX_250]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.CONFIG_FUNCTION_GPS_RMC_ONLY,
        DeviceFeatures.CONFIG_FUNCTION_GPS_TRACKING,
        DeviceFeatures.FUNCTION_5G_NR, // new modified
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING
    ],
    [SupportDeviceModel.MX_250E]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.CONFIG_FUNCTION_GPS_RMC_ONLY,
        DeviceFeatures.CONFIG_FUNCTION_GPS_TRACKING,
        DeviceFeatures.FUNCTION_5G_NR, // new modified
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING
    ],
    [SupportDeviceModel.MX_600]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.CONFIG_FUNCTION_GPS_RMC_ONLY,
        DeviceFeatures.CONFIG_FUNCTION_GPS_TRACKING,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_SECOND_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_WIRELESS_CLIENT,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_SIM,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_STATION_NUMBER,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT
    ],
    [SupportDeviceModel.MX_1000]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_SECOND_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    [SupportDeviceModel.MX_1000E]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_SECOND_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    [SupportDeviceModel.MX_1200]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_GPS,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_SECOND_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_SECOND_4G_LTE,
        DeviceFeatures.FUNCTION_WIRELESS_CLIENT,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_SIM,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],

    /////////////////// Overlap Model Here
    [SupportDeviceModel._4500]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_STATION_NUMBER,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT
    ],
    [SupportDeviceModel._4500AZ]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_STATION_NUMBER,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    [SupportDeviceModel._4500NZ]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_STATION_NUMBER,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    /////////////////// Overlap Model End
    [SupportDeviceModel._4520AZ]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_STATION_NUMBER,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_SIM,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT
    ],
    /////////////////// Overlap Model Here
    [SupportDeviceModel._4700]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_NONE,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP
    ],
    [SupportDeviceModel._4700AZ]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_NONE,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    [SupportDeviceModel._4700ZU]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_NONE,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP
    ],
    /////////////////// Overlap Model End
    /////////////////// Overlap Model Here
    [SupportDeviceModel._4900]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_LTE_TX_POWER
    ],
    [SupportDeviceModel._4900_5G]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_LTE_TX_POWER
    ],
    /////////////////// Overlap Model End

    [SupportDeviceModel._6300VNL]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BRIDGE_MODE,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_NONE,
        DeviceFeatures.FUNCTION_VOIP,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN
    ],
    [SupportDeviceModel._6300NEL]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BRIDGE_MODE,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_NONE,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN
    ],
    /////////////////// Overlap Model Here
    [SupportDeviceModel._6500]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_STATION_NUMBER,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    [SupportDeviceModel._6500AL]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_STATION_NUMBER,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    /////////////////// Overlap Model End
    [SupportDeviceModel._6600]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_STATION_NUMBER,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT
    ],
    [SupportDeviceModel._6900]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_LTE_TX_POWER
    ],
    [SupportDeviceModel._6900_PL9]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_MULTIPL_BAND_SELECT,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_LTE_TX_POWER,
        DeviceFeatures.FUNCTION_3G
    ],
    [SupportDeviceModel._7000]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT,
        DeviceFeatures.CONFIG_FUNCTION_LTE_TX_POWER
    ],
    [SupportDeviceModel._7000_R26_W]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1,
        DeviceFeatures.CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_2,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_NONE,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT,
        DeviceFeatures.CONFIG_FUNCTION_LTE_TX_POWER
    ],
    [SupportDeviceModel._8110]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.FUNCTION_WIRELESS_CLIENT,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_STATION_NUMBER,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT
    ],
    [SupportDeviceModel._8112]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_MULTIPLE_WAN,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.FUNCTION_WIRELESS_CLIENT,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_STATION_NUMBER,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT
    ],
    [SupportDeviceModel._8230]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT,
        DeviceFeatures.CONFIG_FUNCTION_LTE_TX_POWER
    ],
    [SupportDeviceModel._8231]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT,
        DeviceFeatures.CONFIG_FUNCTION_LTE_TX_POWER
    ],
    [SupportDeviceModel._8232]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.MODULE_7516,
        DeviceFeatures.CONFIG_FUNCTION_IPV6_464XLAT
    ],
    [SupportDeviceModel._8235]: [
        DeviceFeatures.PLATFORM_OPENWRT,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP
    ],
    /////////////////// Overlap Model Here
    [SupportDeviceModel._8355]: [
        DeviceFeatures.PLATFORM_OPENWRT,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.OPENWRT_CONFIG_FUNCTION_WAN_USAGE,
        DeviceFeatures.OPENWRT_CONFIG_FUNCTION_SPEED_TEST_SERVER_CUSTOMIZE,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP
    ],
    [SupportDeviceModel._8355P]: [
        DeviceFeatures.PLATFORM_OPENWRT,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.OPENWRT_CONFIG_FUNCTION_WAN_USAGE,
        DeviceFeatures.OPENWRT_CONFIG_FUNCTION_SPEED_TEST_SERVER_CUSTOMIZE,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP
    ],
    [SupportDeviceModel._8355PU]: [
        DeviceFeatures.PLATFORM_OPENWRT,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.FUNCTION_SIGNAL,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PCI_LOCK,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.OPENWRT_CONFIG_FUNCTION_SIM_SELECTION,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_FTP
    ],
    /////////////////// Overlap Model End
    [SupportDeviceModel._8115]: [
        DeviceFeatures.PLATFORM_THIRD_PARTY,
        DeviceFeatures.PLATFORM_ROUTER,
    ],
    [SupportDeviceModel._9900]: [
        DeviceFeatures.COMMAND_DIAGNOSTIC_TOOL,
        DeviceFeatures.PLATFORM_ROUTER,
        DeviceFeatures.ACTION_ALERT_POLICY,
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.FUNCTION_SFP,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BRIDGE_MODE,
        DeviceFeatures.FUNCTION_SECOND_EWAN,
        DeviceFeatures.FUNCTION_VPN,
        DeviceFeatures.CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING,
        DeviceFeatures.FUNCTION_VOIP,
        DeviceFeatures.FUNCTION_HOTSPOT,
        DeviceFeatures.FUNCTION_FTP,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER
    ],
    // PROFILE TEMPLATE
    [SupportDeviceModel.PROFILE_TEMPALTE]: [
        DeviceFeatures.FUNCTION_WI_FI,
        DeviceFeatures.FUNCTION_5G_WI_FI,
        DeviceFeatures.CONFIG_FUNCTION_WI_FI_STATION_NUMBER
    ],
    [SupportDeviceModel.LTE_TEMPALTE]: [
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_NONE,
        DeviceFeatures.CONFIG_FUNCTION_LTE_TX_POWER,
        DeviceFeatures.CONFIG_FUNCTION_MULTIPL_BAND_SELECT,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY
    ],
    [SupportDeviceModel.NR_TEMPALTE]: [
        DeviceFeatures.FUNCTION_4G_LTE,
        DeviceFeatures.FUNCTION_5G_NR,
        DeviceFeatures.CONFIG_FUNCTION_5G_NR_NSA_BAND,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_NONE,
        DeviceFeatures.CONFIG_FUNCTION_LTE_TX_POWER,
        DeviceFeatures.CONFIG_FUNCTION_MULTIPL_BAND_SELECT,
        DeviceFeatures.CONFIG_FUNCTION_IP_PASSTHROUGH,
        DeviceFeatures.CONFIG_FUNCTION_PLMN_SELECTION,
        DeviceFeatures.CONFIG_FUNCTION_DUAL_APN,
        DeviceFeatures.CONFIG_FUNCTION_PDN_TYPE,
        DeviceFeatures.CONFIG_FUNCTION_LEVEL_2_RECOVERY,
        DeviceFeatures.CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY
    ],
    [SupportDeviceModel.EWAN_TEMPALTE]: [
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_NONE
    ],
    [SupportDeviceModel.EWAN_MULTIPLE_SERVICE_TEMPALTE]: [
        DeviceFeatures.FUNCTION_EWAN,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_BANDWIDTH,
        DeviceFeatures.CONFIG_FUNCTION_LAN_DESCRIPTION_NONE,
        DeviceFeatures.CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE
    ],
    [SupportDeviceModel.WIRELESS_CLIENT_TEMPALTE]: [
        DeviceFeatures.FUNCTION_WIRELESS_CLIENT
    ],
    // Remote Power Switch
    [SupportDeviceModel.REMOTE_POWER_SWITCH]: [
        DeviceFeatures.PLATFORM_POWER_SWITCH
    ],
    [SupportDeviceModel.RPS_1000]: [
        DeviceFeatures.PLATFORM_POWER_SWITCH
    ]
};